import { defineStore } from 'pinia';

export const useConfigStore = defineStore('config', {
  state: () => ({
    introduceUrl: '/config/manual.pdf', // 产品介绍链接
    introduceName: '绿萝分发使用手册.pdf', // 产品介绍链接

    manualUrl: '/config/manual.pdf', // 使用手册链接
    manualName: '绿萝分发使用手册.pdf', // 使用手册链接

    clientUrl: 'https://lvluocdn.weilaizhihui.com/1/WEMediaSetup_lvluo##uids##_3.1.0.7407.exe', // 客户端链接
    clientName: '绿萝分发.exe', // 客户端名称

    // 视频链接配置
    addAccount: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 添加账号
    postArticle: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 发文章
    postVideo: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 发视频
    publishingContent: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 发布内容
    helper: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 小助手
    teamManagement: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 团队管理
    subAccount: 'https://xhcdn.weilaizhihui.com/hyy.mp4', // 子账号

    // 二维码
    businessCooperation: '/config/businessCooperation.png', // 商务合作
    onlineService: '/config/onlineService.png', // 在线客服
    officialAccount: '/config/officialAccount.png', // 微信公众号
  }),
  actions: {
    async downloadFile(fileUrl, fileName) {
      try {
        const dmm = window.location.host.match(/(\d{1,5})\.lvluo/i);
        var uids="";
        if(dmm!=null && dmm.length>1){
          uids=dmm[1];
          if(uids.length==1){
            uids="0"+uids;
          }
        }
        const downUrl = fileUrl ? fileUrl : this.clientUrl.replaceAll("##uids##",uids);
        //const downName = fileName ? fileName : this.clientName;

        var p = navigator.platform;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            alert('暂不支持手机端下载，请前往电脑端下载');
            e.preventDefault();
            return false;
        }
        if (p.indexOf("Win") !== 0) {
            alert('抱歉，目前仅支持windows平台！');
            e.preventDefault();
            return false;
        }

        window.location.href = downUrl;

        //const response = await fetch(downUrl);
        //const blob = await response.blob();

        //const url = window.URL.createObjectURL(blob);

        /* const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downUrl;
        a.download = downName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); */

        //window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading the file:', error);
      }
    },
  },
});
